import React from 'react';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const Card: React.FC = props => (
  <Flex
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    textAlign="center"
    paddingY={8}
    paddingX={[6, null, 8]}
    width={[pxToRem(327), null, pxToRem(390)]}
    borderRadius={3}
    boxShadow="0px 9px 36px -30px rgba(0, 0, 0, 0.05), 0px 10px 60px -20px rgba(44, 41, 37, 0.1), 0px 3px 8px 0px rgba(0, 0, 0, 0.05)"
  >
    {props.children}
  </Flex>
);
